import { DateTime } from 'luxon';
import { getResourceRequestTotal } from '~/modules/resourcing/common/enhancers/withResourceRequestTotal';
import { buildUpdatedScheduleRules } from '~/modules/resourcing/common/util/scheduleUtil';

export const useEstimatedRequestTotal = ({
  resourceRequest: {
    startDate,
    endDate,
    scheduleRules = [],
    load,
    roleRate,
    currency
  },
  project: { defaultScheduleRule }
}) =>
  getResourceRequestTotal({
    scheduleRules: buildUpdatedScheduleRules({
      scheduleRules,
      start: DateTime.fromISO(startDate).toUTC(),
      end: DateTime.fromISO(endDate).toUTC(),
      defaultScheduleRule: {
        ...defaultScheduleRule,
        do: {
          ...defaultScheduleRule.do,
          load
        }
      }
    }),
    quantity: 1,
    roleRate,
    currency
  });

export default useEstimatedRequestTotal;
